import {
  SAVE_BANK_DETAILS,
  SAVE_ID_CARD_DETAILS,
  SAVE_SHOP_IMAGE,
  SAVE_A1_BRANDING,
  SAVE_A2_BRANDING,
  SAVE_A3_BRANDING,
  SAVE_PSP_BRANDING,
  SAVE_USER_REGION,
  SAVE_CONTRACT,
  GET_RETAILER_USER_DETAILS,
  GET_SHOP_PHOTO_HISTORY,
  GET_ID_CARD_HISTORY,
  GET_WERBE_HISTORY,
  GET_A1_BRANDING_HISTORY,
  GET_A2_BRANDING_HISTORY,
  GET_A3_BRANDING_HISTORY,
  GET_PSP_BRANDING_HISTORY,
} from 'redux/admin-constants';

const initialState = {
  masterUserList: [],
  totalCount: 0,
  isLoading: false,
  shopPhotoHistory: [],
  idCardHistory: [],
  werbeHistory: [],
  a1BrandingHistory: [],
  a2BrandingHistory: [],
  a3BrandingHistory: [],
  pspBrandingHistory: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SAVE_BANK_DETAILS: {
      return {
        ...state,
        masterUserList: state.masterUserList?.map((item) => {
          const itemId = item.UserID || item.id || item.user_id || item.userid;
          if (itemId === payload.user_id) {
            return {
              ...item,
              bank: payload.bank,
              accountHolderName: payload.accountHolderName,
              iban: payload.iban,
            };
          }
          return item;
        }),
      };
    }
    case SAVE_ID_CARD_DETAILS: {
      return {
        ...state,
        masterUserList: state.masterUserList?.map((item) => {
          const itemId = item.UserID || item.id || item.user_id || item.userid;
          if (itemId === payload.user_id) {
            return {
              ...item,
              idDocumentType: payload.idDocumentType,
              idDocumentNumber: payload.idDocumentNumber,
              ausweisGueltig: payload.ausweisGueltig,
            };
          }
          return item;
        }),
      };
    }
    case SAVE_SHOP_IMAGE: {
      return {
        ...state,
        masterUserList: state.masterUserList?.map((item) => {
          const itemId = String(item.UserID || item.id || item.user_id || item.userid);
          if (itemId === String(payload.user_id)) {
            return {
              ...item,
              Description: payload.description,
              photoDescription: payload.description,
              ...(payload.data?.photoFront || payload.photoFront
                ? {
                    ShopImage: payload.data?.photoFront || payload.photoFront,
                    photoFront: payload.data?.photoFront || payload.photoFront,
                  }
                : {}),
              ...(payload.data?.photoInterior || payload.photoInterior
                ? {
                    ShopImageTwo:
                      payload.data?.photoInterior || payload.photoInterior,
                    photoInterior:
                      payload.data?.photoInterior || payload.photoInterior,
                  }
                : {}),
            };
          }
          return item;
        }),
      };
    }
    case SAVE_A1_BRANDING: {
      return {
        ...state,
        masterUserList: state.masterUserList?.map((item) => {
          const itemId = String(item.UserID || item.id || item.user_id || item.userid);
          if (itemId === String(payload.user_id)) {
            return {
              ...item,
              'A1 Contract Date': payload.a1contractstart,
              anlage1: payload.a1contractstart,
              a1contractstart: payload.a1contractstart,
              A1ContractStart: payload.a1contractstart,
              ' A1ContractStart': payload.a1contractstart,
              a1contractend: payload.a1contractend,
              A1ContractEnd: payload.a1contractend,
              ' A1ContractEnd': payload.a1contractend,
              a1contractcomments: payload.a1contractcomments,
              A1ContractComments: payload.a1contractcomments,
              ' A1ContractComments': payload.a1contractcomments,
              a1period: payload.a1period,
              A1Period: payload.a1period,
              ' A1Period': payload.a1period,
            };
          }
          return item;
        }),
      };
    }
    case SAVE_A2_BRANDING: {
      return {
        ...state,
        masterUserList: state.masterUserList?.map((item) => {
          const itemId = String(item.UserID || item.id || item.user_id || item.userid);
          if (itemId === String(payload.user_id)) {
            return {
              ...item,
              ...(payload.a2contractstart !== undefined && {
                'A2 Contract Date': payload.a2contractstart,
                anlage2: payload.a2contractstart,
                a2contractstart: payload.a2contractstart,
                A2ContractStart: payload.a2contractstart,
                ' A2ContractStart': payload.a2contractstart,
                a2contractend: payload.a2contractend,
                A2ContractEnd: payload.a2contractend,
                ' A2ContractEnd': payload.a2contractend,
                a2contractcomments: payload.a2contractcomments,
                A2ContractComments: payload.a2contractcomments,
                ' A2ContractComments': payload.a2contractcomments,
                a2period: payload.a2period,
                A2Period: payload.a2period,
                ' A2Period': payload.a2period,
              }),
              ...(payload.a2BrandingContract !== undefined && {
                a2BrandingContract: payload.a2BrandingContract,
                hotSpotLight: payload.hotSpotLight,
                hotspotBranding: payload.hotspotBranding,
                brandingStatus: payload.a2BrandingContract ? 'Active' : item.brandingStatus,
              }),
            };
          }
          return item;
        }),
      };
    }
    case SAVE_A3_BRANDING: {
      return {
        ...state,
        masterUserList: state.masterUserList?.map((item) => {
          const itemId = String(item.UserID || item.id || item.user_id || item.userid);
          if (itemId === String(payload.user_id)) {
            return {
              ...item,
              'A3 Contract Date': payload.a3contractstart,
              anlage3: payload.a3contractstart,
              a3contractstart: payload.a3contractstart,
              A3ContractStart: payload.a3contractstart,
              ' A3ContractStart': payload.a3contractstart,
              a3contractend: payload.a3contractend,
              A3ContractEnd: payload.a3contractend,
              ' A3ContractEnd': payload.a3contractend,
              a3contractcomments: payload.a3contractcomments,
              A3ContractComments: payload.a3contractcomments,
              ' A3ContractComments': payload.a3contractcomments,
              a3period: payload.a3period,
              A3Period: payload.a3period,
              ' A3Period': payload.a3period,
            };
          }
          return item;
        }),
      };
    }
    case SAVE_CONTRACT: {
      return {
        ...state,
        masterUserList: state.masterUserList?.map((item) => {
          const itemId = String(item.UserID || item.id || item.user_id || item.userid);
          if (itemId === String(payload.user_id)) {
            const isActive = Number(payload.contractstatus) === 1;
            return {
              ...item,
              contractstatus: isActive ? 'Active' : 'Not Active',
              vertragsstatus: isActive ? 'Active' : 'Not Active',
              accepteddate: isActive ? (payload.contractdate || item.accepteddate) : null,
              contractsdate: isActive ? (payload.contractdate || item.contractsdate) : null,
              fachhandelsver: isActive ? (payload.contractdate || item.fachhandelsver) : '',
            };
          }
          return item;
        }),
      };
    }
    case SAVE_USER_REGION: {
      return {
        ...state,
        masterUserList: state.masterUserList?.map((item) => {
          const itemId = String(item.UserID || item.id || item.user_id || item.userid);
          if (itemId === String(payload.user_id)) {
            return {
              ...item,
              region: payload.region,
              kam: payload.KAMname || payload.kam,
              Kamid: payload.Kamid,
              KAMname: payload.KAMname,
            };
          }
          return item;
        }),
      };
    }
    case SAVE_PSP_BRANDING: {
      return {
        ...state,
        masterUserList: state.masterUserList?.map((item) => {
          const itemId = String(item.UserID || item.id || item.user_id || item.userid);
          if (itemId === String(payload.user_id)) {
            return {
              ...item,
              ...(payload.pspcontractstart !== undefined && {
                PSPContractStart: payload.pspcontractstart,
                psp: payload.pspcontractstart,
                pspcontractstart: payload.pspcontractstart,
                PSPContractEnd: payload.pspcontractend,
                pspcontractend: payload.pspcontractend,
                PSPContractComments: payload.pspcontractcomments || payload.pspcomments,
                pspcontractcomments: payload.pspcontractcomments || payload.pspcomments,
                pspcomments: payload.pspcomments || payload.pspcontractcomments,
                PSPPeriod: payload.PSPPeriod || payload.Pspperiod || payload.pspperiod,
                Pspperiod: payload.Pspperiod || payload.pspperiod,
                pspperiod: payload.pspperiod || payload.Pspperiod,
                period: payload.PSPPeriod || payload.Pspperiod || payload.pspperiod,
              }),
              ...(payload.pspContractStart !== undefined && {
                pspContractStart: payload.pspContractStart,
                werbedisplayAssignedOn: payload.werbedisplayAssignedOn,
                werbedisplayReturned: payload.werbedisplayReturned,
                werbecomments: payload.werbecomments,
                leuchtkastenInstalledOn: payload.leuchtkastenInstalledOn,
                werbedisplay: payload.werbedisplayReturned ? 'Returned' : 'Active',
              }),
            };
          }
          return item;
        }),
      };
    }
    case GET_RETAILER_USER_DETAILS: {
      return {
        ...state,
        masterUserList: Array.isArray(payload?.data) ? payload.data : [],
        totalCount: payload?.totalCount || 0,
      };
    }
    case GET_SHOP_PHOTO_HISTORY: {
      return {
        ...state,
        shopPhotoHistory: Array.isArray(payload) ? payload : [],
      };
    }
    case GET_ID_CARD_HISTORY: {
      return {
        ...state,
        idCardHistory: Array.isArray(payload) ? payload : [],
      };
    }
    case GET_WERBE_HISTORY: {
      return {
        ...state,
        werbeHistory: Array.isArray(payload) ? payload : [],
      };
    }
    case GET_A1_BRANDING_HISTORY: {
      return {
        ...state,
        a1BrandingHistory: Array.isArray(payload) ? payload : [],
      };
    }
    case GET_A2_BRANDING_HISTORY: {
      return {
        ...state,
        a2BrandingHistory: Array.isArray(payload) ? payload : [],
      };
    }
    case GET_A3_BRANDING_HISTORY: {
      return {
        ...state,
        a3BrandingHistory: Array.isArray(payload) ? payload : [],
      };
    }
    case GET_PSP_BRANDING_HISTORY: {
      return {
        ...state,
        pspBrandingHistory: Array.isArray(payload) ? payload : [],
      };
    }
    default:
      return state;
  }
};

export default reducer;
